export enum OperationType {
  CREATE = "CREATE",
  UPDATE = "UPDATE"
}
